import React from "react";
import { LastMonthRevenueCard } from "./LastMonthRevenueCard";
import { LastMonthInsightsPanel } from "./LastMonthInsightsPanel";
import { useLastMonthRevenue } from "../../hooks/useLastMonthRevenue";
import { useLastMonthRevenueInsights } from "../../hooks/useLastMonthRevenueInsights";

export function LastMonthRevenueReviewSection() {
  const {
    monthLabel,
    statusLabel,
    revenueAmount,
    momPercent,
    ebitdaPercent,
    barHeights,
    barLabels,
    barAmounts,
    loading,
    error: revenueError,
  } = useLastMonthRevenue();

  const insightsData = useLastMonthRevenueInsights({
    enabled: !loading && !revenueError,
  });

  const insightsMonthLabel =
    insightsData.monthLabel !== ""
      ? `${insightsData.monthLabel} · Insights`
      : (monthLabel ?? "").replace(" · Closed", " · Insights");

  const insightsPanelLoading = loading || insightsData.loading;
  const insightsToShow = insightsData.error ? [] : insightsData.insights;

  return (
    <div className="flex w-full flex-col items-start gap-4 rounded-lg bg-white px-6 py-6 shadow-sm">
      <div className="flex w-full gap-6 items-stretch">
        <LastMonthRevenueCard
          monthLabel={monthLabel}
          statusLabel={statusLabel}
          revenueAmount={revenueAmount}
          momPercent={momPercent}
          ebitdaPercent={ebitdaPercent}
          barHeights={barHeights}
          barLabels={barLabels}
          barAmounts={barAmounts}
          loading={loading}
        />
        <LastMonthInsightsPanel
          monthLabel={insightsMonthLabel}
          insights={insightsToShow}
          loading={insightsPanelLoading}
        />
      </div>
    </div>
  );
}
